import React, { useMemo } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { queryFilter, useQueryFilters } from '../../hooks/useQueryFilters';
import { canAccessFullAdministration } from '../../utils/permissions';
import UsersTab from './tabs/UsersTab';
import SubscriptionPlansTab from './tabs/SubscriptionPlansTab';
import FinanceiroTab from './tabs/FinanceiroTab';
import GatewaySyncTab from './tabs/GatewaySyncTab';
import EquipamentosTab from './tabs/EquipamentosTab';
import ImportacoesTab from './tabs/ImportacoesTab';
import { AdminPageShell, AdminTabbedPanel } from '../../components/common/AdminPageLayout/AdminPageLayout';

const FULL_ADMIN_TABS = [
  { key: 'usuarios', label: 'Usuários' },
  { key: 'assinaturas', label: 'Assinaturas' },
  { key: 'equipamentos', label: 'Equipamentos' },
  { key: 'financeiro', label: 'Financeiro' },
  { key: 'sincronizacao', label: 'Sincronização' },
  { key: 'importacoes', label: 'Importações' },
] as const;

const SUPPORT_ADMIN_TABS = [
  { key: 'assinaturas', label: 'Assinaturas' },
] as const;

const Administration: React.FC = () => {
  const { roles } = useAuth();
  const isFullAdmin = canAccessFullAdministration(roles);
  const tabs = useMemo(
    () => (isFullAdmin ? FULL_ADMIN_TABS : SUPPORT_ADMIN_TABS),
    [isFullAdmin],
  );
  const tabSchema = useMemo(() => {
    const allowedTabs = tabs.map(({ key }) => key);
    return {
      tab: queryFilter.enum(allowedTabs[0], allowedTabs),
    };
  }, [tabs]);
  const { filters, setFilter } = useQueryFilters(tabSchema);
  const activeKey = filters.tab;

  return (
    <AdminPageShell>
      <AdminTabbedPanel
        tabs={tabs}
        activeKey={activeKey}
        onTabChange={(key) => setFilter('tab', key as typeof activeKey, { replace: false })}
      >
        {isFullAdmin && activeKey === 'usuarios' && <UsersTab />}
        {activeKey === 'assinaturas' && <SubscriptionPlansTab />}
        {isFullAdmin && activeKey === 'equipamentos' && <EquipamentosTab />}
        {isFullAdmin && activeKey === 'financeiro' && <FinanceiroTab />}
        {isFullAdmin && activeKey === 'sincronizacao' && <GatewaySyncTab />}
        {isFullAdmin && activeKey === 'importacoes' && <ImportacoesTab />}
      </AdminTabbedPanel>
    </AdminPageShell>
  );
};

export default Administration;
